// extracted by css-extract-rspack-plugin
export default {"cls1":"CitationModal-cls1_9PU","cls2":"CitationModal-cls2_Q3D CitationModal-cls1_9PU"};